import script from "./question-answering.vue?vue&type=script&setup=true&lang=js"
export * from "./question-answering.vue?vue&type=script&setup=true&lang=js"

import "./question-answering.vue?vue&type=style&index=0&id=6138c382&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6138c382"]])

export default __exports__